import Modal from "@/common/components/Modal";
import { useBillingBillRemoveFailure } from "../../hooks/useBillingBillRemoveFailure";
import { Dispatch, SetStateAction, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";

interface BillRemoveFailureModalProps {
  billId?: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const BillRemoveFailureModal = ({ billId, isOpen, setIsOpen }: BillRemoveFailureModalProps) => {
  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: removeFailure,
    isPending: removeFailureIsPending,
  } = useBillingBillRemoveFailure({
    billId,
    onSuccess: () => {
      setIsOpen(false);
      queryClient.invalidateQueries({ queryKey: ['billingBill', billId] });
    },
    onError: (response) => {
      setIsOpen(false);
      setMessages(response.response?.data.errors.base || ['Ocorreu um erro ao marcar falha como resolvida'])
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        subtitle="A falha dessa fatura será marcada como resolvida"
        subtitleClassName="mt-1 text-white-400"
        useCancellableFooter
        showClose={false}
        confirmButtonClassName="bg-primary-blue"
        confirmButtonIsLoading={removeFailureIsPending}
        dataTestid="confirm_remove_failure"
        onConfirm={removeFailure}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default BillRemoveFailureModal;
